import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrderTypeState } from '../reducers';

export const selectOrderTypeState = createFeatureSelector<OrderTypeState>('orderType');

export const selectOrderTypeLoading = createSelector(
  selectOrderTypeState,
  (state: OrderTypeState) => state.loading
);

export const selectOrderType = createSelector(
  selectOrderTypeState,
  (state: OrderTypeState) => state.orderType
);

export const selectOrderTypeList = createSelector(
  selectOrderTypeState,
  (state: OrderTypeState) => state.orderTypeList
);

export const selectOrderTypeError = createSelector(
  selectOrderTypeState,
  (state: OrderTypeState) => state.error
);
